var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kst-page-new',{on:{"init":_vm.handleInit,"submit":_vm.handleSubmit}},[_c('Details',{attrs:{"userData":_vm.userData}}),_c('ModuleAttrRelatedGlobalInput',{attrs:{"moduleAttrList":_vm.userModuleAttrList}}),_c('ModuleList',{attrs:{"userModule":_vm.userModule,"userModuleAttrList":_vm.userModuleAttrList,"moduleList":_vm.moduleList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }